import tippy from 'tippy.js';

export default () => {
  let windowWidth = window.innerWidth;
  const items = document.querySelectorAll('.contribution__item');

  items.forEach((item) => {
    const inner = item.querySelector('.contribution__item-inner');
    const tooltip = item.querySelector('.contribution__tooltip');
    const tooltipContent = tooltip?.innerHTML || null;
    const smallTooltip = item.hasAttribute('data-small-tooltip');

    if (!tooltipContent) return;

    const tooltipClose = tooltip.querySelector('.tooltip-info__close');

    let tippyInstance;

    function init() {
      if (windowWidth >= 999) {
        tooltip.classList.remove('opened');
        if (tippyInstance) {
          tippyInstance.enable();
        } else {
          tippyInstance = tippy(item, {
            content: tooltipContent,
            duration: 0,
            delay: [200, 0],
            allowHTML: true,
            maxWidth: smallTooltip ? 300 : 500,
            interactive: true,
          });
        }
      } else {
        tippyInstance && tippyInstance.disable();
      }
    }

    inner.addEventListener('click', () => {
      if (windowWidth < 999) {
        items.forEach((item) => {
          item.querySelector('.contribution__tooltip')?.classList.remove('opened');
        });
        tooltip.classList.add('opened');
      }
    });

    tooltipClose.addEventListener('click', (event) => {
      event.preventDefault();
      tooltip.classList.remove('opened');
    });

    window.addEventListener('widthResize', () => {
      windowWidth = window.innerWidth;
      init();
    });

    init();
  });
};
